/**
 * @file 平台注册器
 * @description 单例模式，运行时绑定当前平台策略实现
 */

import type { IPlatformStrategy } from './types'
import { PlatformType } from './types'

class PlatformRegistry {
  private static instance: PlatformRegistry
  private currentPlatform: IPlatformStrategy | null = null

  private constructor() {}

  static getInstance(): PlatformRegistry {
    if (!PlatformRegistry.instance) {
      PlatformRegistry.instance = new PlatformRegistry()
    }
    return PlatformRegistry.instance
  }

  /** 注册当前平台策略（在 bootstrap 中调用一次） */
  register(strategy: IPlatformStrategy): void {
    this.currentPlatform = strategy
    console.log(`[Platform] 已注册平台: ${strategy.type}`)
  }

  /** 获取当前平台策略 */
  get platform(): IPlatformStrategy {
    if (!this.currentPlatform) {
      throw new Error(
        '[Platform] 平台策略未注册，请在 bootstrap 中调用 registerPlatform()'
      )
    }
    return this.currentPlatform
  }

  /** 获取平台类型 */
  get type(): PlatformType {
    return this.platform.type
  }

  /** 判断当前是否为指定平台 */
  is(type: PlatformType): boolean {
    return this.currentPlatform?.type === type
  }

  /** 是否已注册 */
  get isRegistered(): boolean {
    return this.currentPlatform !== null
  }
}

export const platformRegistry = PlatformRegistry.getInstance()
